// @flow
import React from 'react';
import { h, render, Component } from 'preact';

export default class InputField extends Component {
  render() {
    const name = this.props.formfield.name;
    const value = this.props.formfield.defaultData;

    return (
      <div id={this.props.fieldId}
           className={`labelfieldBlock ${name}`}>
        <div
          id={`formfield_${name}`}
          className={`labelfield ${name}`}
        >
          {value}
        </div>
      </div>
    );
  }
}
